import * as CMSAddressesThunks from './CMSAddressesThunks';

export const getDeliveryAddresses = () =>
  CMSAddressesThunks.getDeliveryAddresses();

export const createDeliveryAddress = (data, formId) =>
  CMSAddressesThunks.createDeliveryAddress(data, formId);

export const updateDeliveryAddress = (data, formId) =>
  CMSAddressesThunks.updateDeliveryAddress(data, formId);

export const deleteDeliveryAddress = (addressId, formId) =>
  CMSAddressesThunks.deleteDeliveryAddress(addressId, formId);
